import * as colors from 'src/styles/colors';

import BgPatentSearchBanner from 'src/assets/images/bg_search_patent.png';
import BgTradeMarkSearchBanner from 'src/assets/images/bg_search_trademark.png';
import BgPatentBanner from 'src/assets/images/bg_patent_banner.png';
import BgTmarkBanner from 'src/assets/images/bg_tmark_banner.png';
import BgCertBanner from 'src/assets/images/bg_cert_banner.png';
import BgPatentBannerMobile from 'src/assets/images/bg_top_patent.png';
import BgTradeMarkBannerMobile from 'src/assets/images/bg_top_trademark.png';
import ImgPatent from 'src/assets/images/tipo_patent.png';
import ImgTrademark from 'src/assets/images/tipo_trademark.png';
import ImgCertificate from 'src/assets/images/tipo_certificate.png';
import ImgPatentHover from 'src/assets/images/tipo_patent_hover.png';
import ImgTrademarkHover from 'src/assets/images/tipo_trademark_hover.png';
import ImgCertificateHover from 'src/assets/images/tipo_certificate_hover.png';
import ImgPatentDot from 'src/assets/images/tipo_dot_patent.png';
import ImgTmarkDot from 'src/assets/images/tipo_dot_trademark.png';
import ImgCertDot from 'src/assets/images/tipo_dot_certificate.png';

import BookPatent from 'src/assets/images/img_book_patent.png';
import QrBookPatent from 'src/assets/images/img_qrbook_patent.png';
import BookTmark from 'src/assets/images/img_book_tmark.png';
import QrBookTmark from 'src/assets/images/img_qrbook_tmark.png';

/** 功能基本顏色(50, 100, 200, 300, 400, 500)。 */
export interface PrimaryColors {
  first: string;
  second: string;
  third: string;
  forth: string;
  fifth: string;
  sixth: string;
  seventh: string;
}

/** 功能項目屬性。 */
export const globalComponents = {
  P: {
    title: '專利權證',
    color: {
      first: colors.primaryEggplant_30,
      second: colors.primaryEggplant_50,
      third: colors.primaryEggplant_100,
      forth: colors.primaryEggplant_200,
      fifth: colors.primaryEggplant_300,
      sixth: colors.primaryEggplant_400,
      seventh: colors.primaryEggplant_500,
    },
    image: ImgPatent,
    hoverImage: ImgPatentHover,
    bgImgBanner: BgPatentSearchBanner,
    bgImgResultBanner: BgPatentBanner,
    bgImgBannerMobile: BgPatentBannerMobile,
    bgImgDot: ImgPatentDot,
    searchPageImgs: {
      bookImg: BookPatent,
      qrBookImg: QrBookPatent,
    },
  },
  T: {
    title: '商標權證',
    color: {
      first: colors.primaryBlue_30,
      second: colors.primaryBlue_50,
      third: colors.primaryBlue_100,
      forth: colors.primaryBlue_200,
      fifth: colors.primaryBlue_300,
      sixth: colors.primaryBlue_400,
      seventh: colors.primaryBlue_500,
    },
    image: ImgTrademark,
    hoverImage: ImgTrademarkHover,
    bgImgBanner: BgTradeMarkSearchBanner,
    bgImgResultBanner: BgTmarkBanner,
    bgImgBannerMobile: BgTradeMarkBannerMobile,
    bgImgDot: ImgTmarkDot,
    searchPageImgs: {
      bookImg: BookTmark,
      qrBookImg: QrBookTmark,
    },
  },
  C: {
    title: '電子證書',
    color: {
      first: colors.primaryOrange_30,
      second: colors.primaryOrange_50,
      third: colors.primaryOrange_100,
      forth: colors.primaryOrange_200,
      fifth: colors.primaryOrange_300,
      sixth: colors.primaryOrange_400,
      seventh: colors.primaryOrange_500,
    },
    image: ImgCertificate,
    hoverImage: ImgCertificateHover,
    bgImgBanner: '',
    bgImgResultBanner: BgCertBanner,
    bgImgBannerMobile: '',
    bgImgDot: ImgCertDot,
    searchPageImgs: {
      bookImg: '',
      qrBookImg: '',
    },
  },
};

/** 搜尋結果樣式。 */
export enum FormType {
  list = '列表式',
  table = '表格式',
}
